import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "../../utils/toast";

import { forgotPassword } from "../../api/auth";
import AuthLayout from "../../components/UX/AuthLayout";
import Button from "../../components/UX/Button";
import TextInput from "../../components/UX/TextInput";

const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailPattern.test(email.toLowerCase())) {
      toast.error("Veuillez saisir une adresse e-mail valide.");
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email.toLowerCase());
      setSent(true);
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Impossible d'envoyer l'e-mail de réinitialisation."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      headerLink={
        <>
          Mot de passe retrouvé ?{" "}
          <Link to="/login" className="text-primaryText underline">
            Se connecter
          </Link>
        </>
      }
    >
      <div className="text-center mb-2">
        <h1 className="font-logo text-3xl md:text-4xl text-black mb-3">
          Réinitialiser ton mot de passe
        </h1>
        <p className="font-josefin text-secondaryText text-sm md:text-base">
          Saisis ton adresse e-mail pour recevoir un lien de réinitialisation.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <TextInput
          id="forgot-email"
          type="email"
          placeholder="Adresse e-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
          disabled={sent}
        />
        <Button type="submit" disabled={loading || sent}>
          {loading ? "Envoi…" : "Recevoir le lien"}
        </Button>
      </form>

      {sent && (
        <p className="font-josefin text-sm text-secondaryText text-center leading-relaxed">
          L&apos;e-mail de réinitialisation a été envoyé. Consulte ta boîte de
          réception (et tes spams si nécessaire).
        </p>
      )}
    </AuthLayout>
  );
}

export default ForgotPassword;
